import React from 'react';

interface MapleLeafProps {
  size?: number;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
}

/** Simple maple leaf mark for Canadian branding (Lucide has no maple icon). */
export const MapleLeaf: React.FC<MapleLeafProps> = ({
  size = 16,
  color = 'currentColor',
  className,
  style
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={color}
    aria-hidden="true"
    className={className}
    style={style}
  >
    <path d="M12 2.2l1.1 3.6 3.1-2.2-.8 3.9 3.9-.6-2.3 3.2 3.6 1.5-3.7 1.2 1.8 3.4-3.9-1-1.2 4.6L12 21.8l-1.6-5.6-3.9 1 1.8-3.4-3.7-1.2 3.6-1.5-2.3-3.2 3.9.6-.8-3.9 3.1 2.2L12 2.2z" />
  </svg>
);
